'use client';

import { useLocale } from 'next-intl';
import dynamic from 'next/dynamic';
import React from 'react';

import { Header } from '@ui/sections/header/Header';
import { useUserType } from '@website/hooks/useCurrentUser';
import { useHasMounted } from '@website/hooks/useHasMounted';

const HeaderAuthSection = dynamic(() => import('./HeaderAuthSection').then((mod) => mod.HeaderAuthSection), {
  ssr: false,
  loading: () => <div></div>
});

interface AppHeaderProps {
  rightActions?: React.ReactNode;
}

/**
 * Application-specific header component for the website.
 * Fully static - auth section is a client component that handles user state.
 */
export default function AppHeader({ rightActions }: AppHeaderProps) {
  const locale = useLocale();
  const userType = useUserType();
  const hasMounted = useHasMounted();

  const logoHref = hasMounted && userType === 'professional' ? `/${locale}/dashboard` : `/${locale}`;

  return (
    <Header
      logoHref={logoHref}
      rightActions={
        <>
          {rightActions}
          <HeaderAuthSection />
        </>
      }
    />
  );
}
